var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeduction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.875,
    y: 20.6643,
    width: 23.25,
    height: 14.684,
    rx: 2.44735,
    stroke: "currentColor",
    strokeWidth: 1.9375,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1719 14.0872L26.3923 11.3077C26.1534 11.0687 25.766 11.0687 25.5271 11.3077L22.7475 14.0872",
    stroke: "currentColor",
    strokeWidth: 1.9375,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9597 17.605L25.9597 11.4866",
    stroke: "currentColor",
    strokeWidth: 1.9375,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 24.4714H21.1264C23.1289 24.4714 24.7521 26.0947 24.7521 28.0971V28.0971C24.7521 30.0996 23.1289 31.7229 21.1264 31.7229H13.875V24.4714Z",
    stroke: "currentColor",
    strokeWidth: 1.9375,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5795 28.0972C21.5795 28.5978 21.1737 29.0036 20.6731 29.0036C20.1725 29.0036 19.7667 28.5978 19.7667 28.0972C19.7667 27.5966 20.1725 27.1908 20.6731 27.1908C21.1737 27.1908 21.5795 27.5966 21.5795 28.0972Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.906428
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeduction);
export default __webpack_public_path__ + "static/media/Deduction.b730ce9fc239bd887d45ddaa3b7da47e.svg";
export { ForwardRef as ReactComponent };